export interface PaymentPlan {
  installmentAmount: number
  installments: number
  initialAmount: number
}

export enum PaymentPlanStatus {
  CREATED = 'created',
  ACTIVE = 'active',
  PAYED = 'payed',
  CANCELLED = 'cancelled',
}
